var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flash-messages__message", class: _vm.containerClass },
    [
      _c("div", { staticClass: "flash-message__message-text" }, [
        _vm._v(_vm._s(_vm.theMessage.text))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flash-message__dismiss" }, [
        _vm.theMessage.dismissable
          ? _c(
              "button",
              {
                staticClass:
                  "flash-message__button flash-message__button--close",
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.dismissMessage($event)
                  }
                }
              },
              [
                _c("span", {
                  staticClass: "glyphicon glyphicon-remove",
                  attrs: { "aria-hidden": "true" }
                })
              ]
            )
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }